// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    suggestionStyle2MainContainerSelector: "#header .header_top",
    suggestionMobileStyle:"style2"
  }
};

(function() {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }

  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.search-button').on('click', function() {
    setTimeout(function() {
      jQ('.boost-pfs-search-suggestion-wrapper, .boost-pfs-search-suggestion-mobile-overlay, .boost-pfs-search-suggestion-mobile-top-panel').remove();
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });


    jQ(document).on("focusout", ".boost-pfs-search-box", function() {
        jQ('body').removeClass('boost-pfs-search-suggestion-open-body')
    });

    jQ(document).on("blur", ".boost-pfs-search-box", function() {
        jQ('body').removeClass('boost-pfs-search-suggestion-open-body')
    });

  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function () {
    // If the multi-currency feature is enabled, update the product price
    this.prepareSuggestionProductPriceData();
    // Check on sale
    var onSale = this.data.compare_at_price_min > this.data.price_min;
    // Format price
    var price = Utils.formatMoney(this.data.price_min);
    var compareAtPrice = '';
    if (this.data && this.data.compare_at_price_min) {
      compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
      if (Settings.getSettingValue('search.removePriceDecimal')) {
        price = Utils.removeDecimal(price);
        compareAtPrice = Utils.removeDecimal(compareAtPrice);
      }
    }

    // Build Price
    var result = '';
    if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
      if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
        result += '<div class="boost-pfs-price-sale-container">'
        // result += this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
        result += this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
        result += '<div class="boost-pfs-percent-off-flag">' + this.data.percent_sale_min +'% off'+ '</div>';
        result += '</div>';
      } else {
        result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
      }
    }
    return result
        .replace(/{{regularPrice}}/g, price)
        .replace(/{{compareAtPrice}}/g, compareAtPrice);
  }

    InstantSearchResultItemProduct.prototype.compileTemplate = function(data){
        if (this.isShow) {
            var searchTerm = Utils.stripHtml(Globals.currentTerm);
            // Product image
            var imageHTML = '';
            if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
                imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
                imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
            }
            // Product title
            var productTitle = this.customizeProductTitle();
            productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
            // SKU
            var skuHTML = '';
            if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
                skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
                skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
            }
            // Vendor
            var vendorHTML = '';
            if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
                vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
                vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
            }
            // Price
            var priceHTML = this.compileSuggestionProductPrice();
            // Open the result item in new tab when selected
            var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

            var fixedUrl = '';
            if (this.url.slice(0,5) == '/cart') {
                fixedUrl = this.url.slice(5);
            }else {
                fixedUrl = this.url;
            }
            return this.getTemplate()
                .replace(/{{id}}/g, this.id)
                .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
                .replace(/{{url}}/g, fixedUrl)
                .replace(/{{newTabAttribute}}/g, newTabAttr)
                .replace(/{{itemProductImage}}/g, imageHTML)
                .replace(/{{title}}/g, productTitle)
                .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
                .replace(/{{itemProductSku}}/g, skuHTML)
                .replace(/{{itemProductVendor}}/g, vendorHTML)
                .replace(/{{itemProductPrice}}/, priceHTML)
                .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
                .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
                .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
        } else {
            return '';
        }
    }
})();
